export default "__VITE_ASSET__CgFp4XU$__"